import { FC, useState } from 'react';
import { cn } from '@/utils/cn';

interface CodeBlockProps {
  code: string;
  language?: string;
  title?: string;
  className?: string;
}

export const CodeBlock: FC<CodeBlockProps> = ({ 
  code, 
  language = 'bash', 
  title,
  className 
}) => {
  const [copied, setCopied] = useState(false);

  const cleanCodeForCopy = (code: string): string => {
    // 移除命令行前缀如 "$", "PS>", "# " 等
    return code
      .split('\n')
      .map(line => {
        // 移除常见的命令行前缀
        const trimmedLine = line.trim();
        // 匹配并移除 "$ ", "PS> ", "PS>" 等前缀
        if (trimmedLine.startsWith('$ ')) {
          return trimmedLine.substring(2);
        }
        if (trimmedLine.startsWith('PS> ') || trimmedLine.startsWith('PS>')) {
          return trimmedLine.replace(/^PS>\s*/, '');
        }
        // 保留注释行不变
        if (trimmedLine.startsWith('#')) {
          return trimmedLine;
        }
        return trimmedLine;
      })
      .join('\n')
      .trim();
  };

  const copyToClipboard = async () => {
    try {
      const cleanedCode = cleanCodeForCopy(code);
      await navigator.clipboard.writeText(cleanedCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  return (
    <div className={cn('relative bg-gray-900 rounded-lg overflow-hidden', className)}>
      {title && (
        <div className="bg-gray-800 px-4 py-2 text-sm text-gray-300 border-b border-gray-700">
          {title}
        </div>
      )}
      
      <div className="relative">
        <pre className="p-4 overflow-x-auto text-sm">
          <code className={`language-${language} text-gray-100`}>
            {code}
          </code>
        </pre>
        
        <button
          onClick={copyToClipboard}
          className="absolute top-2 right-2 bg-gray-700 hover:bg-gray-600 text-gray-300 hover:text-white px-3 py-1 rounded text-xs transition-colors"
        >
          {copied ? '已复制!' : '复制'}
        </button>
      </div>
    </div>
  );
};